import React, { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Button,
  Link,
  Box,
  Stack,
  IconButton,
  Drawer,
  List,
  ListItemButton,
  ListItemText,
  Divider,
} from "@mui/material";
import { Link as ScrollLink } from "react-scroll";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";

import logoUrl from "../assets/images/logo-svg1.svg";

const NAV_LINKS = [
  { label: "Serviços Extras", to: "/vitrine" }, // not published yet
  { label: "Mapa de Parceiros", to: "/mapa-parceiros" },
];

function NavbarClient() {
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="fixed">
        <Toolbar className="App-header">
          <Link component={RouterLink} to="/" sx={{ mr: 2 }}>
            <Box
              sx={{
                width: "auto",
                height: { xs: "40px", sm: "40px", md: "60px", lg: "60px" },
              }}
            >
              <img
                src={logoUrl}
                alt="Logo"
                style={{ width: "100%", height: "100%" }}
              />
            </Box>
          </Link>

          <Box sx={{ flexGrow: 1 }} />

          {/* Desktop nav */}
          <Box sx={{ display: { xs: "none", md: "flex" } }} className="App-link">
            <Stack direction="row" spacing={2}>
              <ScrollLink
                to="como-funciona"
                hashSpy={true}
                smooth={true}
                duration={500}
                offset={-150}
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <Button color="inherit">Como funciona</Button>
              </ScrollLink>
              <ScrollLink
                to="vantagens"
                hashSpy={true}
                smooth={true}
                duration={500}
                offset={-130}
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <Button color="inherit">Vantagens</Button>
              </ScrollLink>
              {NAV_LINKS.map((link) => (
                <Button
                  key={link.to}
                  component={RouterLink}
                  to={link.to}
                  color="inherit"
                  sx={{ textTransform: "none" }}
                >
                  {link.label}
                </Button>
              ))}
            </Stack>
          </Box>

          {/* Mobile hamburger */}
          <IconButton
            color="inherit"
            edge="end"
            aria-label="menu"
            onClick={() => setDrawerOpen(true)}
            sx={{ display: { xs: "flex", md: "none" } }}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      {/* Mobile drawer */}
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        PaperProps={{ sx: { width: 240 } }}
      >
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", px: 1, py: 0.5 }}>
          <IconButton onClick={() => setDrawerOpen(false)} aria-label="fechar menu">
            <CloseIcon />
          </IconButton>
        </Box>
        <Divider />
        <List disablePadding>
          <ListItemButton component="a" href="/#como-funciona" onClick={() => setDrawerOpen(false)}>
            <ListItemText primary="Como funciona" />
          </ListItemButton>
          <ListItemButton component="a" href="/#vantagens" onClick={() => setDrawerOpen(false)}>
            <ListItemText primary="Vantagens" />
          </ListItemButton>
          <Divider />
          {NAV_LINKS.map((link) => (
            <ListItemButton
              key={link.to}
              component={RouterLink}
              to={link.to}
              onClick={() => setDrawerOpen(false)}
            >
              <ListItemText primary={link.label} />
            </ListItemButton>
          ))}
        </List>
      </Drawer>
    </Box>
  );
}

export default NavbarClient;
